import { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux'
import { loginUser } from "../features/user/userSlice";
import {
  Container,
  Form,
  Grid,
  Segment,
  Button,
  Message,
  Icon
} from "semantic-ui-react";


const Login = (props) => {
  const [loginMessage, setLoginMessage] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  let [searchParams] = useSearchParams();
  const nextLocation = searchParams.get("nextLocation");
  const dispatch = useDispatch();

  // Sign-in is through Authentik / Active Directory. The password form below is only shown with ?local=1
  // (and the server refuses password logins entirely while SSO_ONLY=true).
  const ssoError = searchParams.get("sso_error");
  const showLocal = true; // Texas site: local accounts only, no SSO
  const ssoUrl = process.env.REACT_APP_ACCOUNT_SERVER + "/sso/login?nextLocation=" + encodeURIComponent(nextLocation || "frontend");
  const ssoMessages = {
    notallowed: "Your account is not allowed to use this site. Ask an administrator to add you to the radio group.",
    disabled: "This account has been disabled.",
    denied: "Sign-in was cancelled or refused.",
    expired: "That sign-in attempt expired. Please try again.",
    unavailable: "The sign-in service (Authentik) is not reachable right now. Are you on the VPN?",
    failed: "Sign-in failed. Please try again."
  };
  useEffect(() => {
    if (!ssoError && !showLocal) window.location = ssoUrl;
  }, [ssoError, showLocal, ssoUrl]);

  const loginSubmit = async (event) => {
    event.preventDefault();
    const result = await dispatch(loginUser({ screenName: username, password })).unwrap();
    if (result.success) {
      if (nextLocation) {
        switch (nextLocation) {
          case "admin":
            window.location = process.env.REACT_APP_ADMIN_SERVER;
            break;
          case "account":
            navigate("/");
            break;
          case "frontend":
          default:
            window.location = process.env.REACT_APP_FRONTEND_SERVER;
            break;
        }
      } else {
        // No explicit destination (e.g. logging in directly on the account
        // site) - go straight to the radio homepage instead of this app's
        // own account page.
        window.location = process.env.REACT_APP_FRONTEND_SERVER;
      }
      console.log(result)
    } else {
      console.error(result);
      setLoginMessage(result.message);
    }
  }

  let loginMessageDisplay = (<></>)

  if (loginMessage) {
    loginMessageDisplay = (
      <Message icon>
        <Icon name="lemon" />
        <Message.Content>
          <Message.Header>Problems...</Message.Header>
          {loginMessage}
        </Message.Content>
      </Message>
    );
  }

  if (!showLocal) {
    return (
      <Container>
        <Grid stackable centered>
          <Grid.Row>
            <Grid.Column width={6}>
              <Segment padded textAlign="center">
                {ssoError ? (
                  <Message negative>
                    <Message.Content>{ssoMessages[ssoError] || ssoMessages.failed}</Message.Content>
                  </Message>
                ) : (
                  <p>Redirecting to sign-in...</p>
                )}
                <Button as="a" href={ssoUrl} size="large" fluid primary>
                  <Icon name="sign-in" /> Sign in with Authentik / AD
                </Button>
              </Segment>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    );
  }

  return (
    <Container>
      <Grid stackable centered>
        <Grid.Row>
          <Grid.Column width={6}>
            <Form onSubmit={loginSubmit}>
              <Segment padded>
                <Form.Field>
                  <Form.Input
                    icon="user"
                    iconPosition="left"
                    type="text"
                    name="screenName"
                    onChange={e => setUsername(e.target.value)}
                    value={username}
                    placeholder="Username"
                  />
                </Form.Field>
                <Form.Field>
                  <Form.Input
                    icon="lock"
                    iconPosition="left"
                    type="password"
                    name="password"
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                    placeholder="Password"
                  />
                </Form.Field>

                <Button type="submit" size="large" value="Login" fluid primary>
                  Login
                </Button>
                {loginMessageDisplay}
              </Segment>
            </Form>
            <Button
              size="large"
              content="Register"
              onClick={() => navigate("/register")}
              fluid
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Container>
  );
}


export default Login;
